import { render, staticRenderFns } from "./HTage.vue?vue&type=template&id=13b5b01e&scoped=true"
import script from "./HTage.vue?vue&type=script&lang=js"
export * from "./HTage.vue?vue&type=script&lang=js"
import style0 from "./HTage.vue?vue&type=style&index=0&id=13b5b01e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5b01e",
  null
  
)

export default component.exports